import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

// SMS gönderim logunu Firestore 'smsLogs' koleksiyonuna yazar (localStorage yerine).
export async function logSms(params: {
  alici: string;     // telefon
  aliciAd: string;   // ad
  mesaj: string;
  durum: "gönderildi" | "hata";
}): Promise<void> {
  try {
    await addDoc(collection(db, "smsLogs"), {
      tarih: serverTimestamp(),
      alici: params.alici,
      aliciAd: params.aliciAd,
      mesaj: params.mesaj,
      durum: params.durum,
    });
  } catch (e) {
    console.error("SMS log yazılamadı:", e);
  }
}
